module.exports = __webpack_public_path__ + "img/examples-ru-4.c6531676.jpg";